import React from 'react';
import {
  createBasicColorSet,
  cssColorSet,
  LoadingIndicator,
} from '@spotify-internal/encore-web';
import { css } from 'emotion';
import styled from '@emotion/styled';

export type WrapperLoadingIndicatorProps = {
  height?: number;
  color?: string;
};

export type CenteredLoadingIndicatorProps = Pick<
  WrapperLoadingIndicatorProps,
  'height'
> & {
  size?: 'sm' | 'md' | 'lg';
};

export type PageLoadingIndicatorProps = Pick<
  WrapperLoadingIndicatorProps,
  'color'
>;

const Wrapper = styled.div<WrapperLoadingIndicatorProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => {
    return height ? `${height}px` : '100%';
  }};
  background: ${({ color }) => color}};
`;

export const CenteredLoadingIndicator = (
  props: CenteredLoadingIndicatorProps
) => {
  const { height, size = 'sm' } = props;
  return (
    <Wrapper height={height} data-testid="loadingSpinner">
      <LoadingIndicator indicatorSize={LoadingIndicator[size]} />
    </Wrapper>
  );
};

export const PageLoadingIndicator = (props: PageLoadingIndicatorProps) => {
  const { color } = props;
  return (
    <Wrapper height={400} color={color} data-testid="loadingSpinner">
      <LoadingIndicator indicatorSize={LoadingIndicator.lg} />
    </Wrapper>
  );
};

/** Takes a foreground and background color. Returns a color set object . */
const SpinnerCustomColor = createBasicColorSet('#000000', '#000000');
/** Takes a color set object. Returns a set of semantic CSS variables. */
const cssCustomColorSet = cssColorSet(SpinnerCustomColor);

const InvertedWrapper = styled.div<WrapperLoadingIndicatorProps>`
  ${cssCustomColorSet}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => {
    return height ? `${height}px` : '100%';
  }};
  background: ${({ color }) => color}};
`;

export const InvertedLoadingIndicator = (
  props: WrapperLoadingIndicatorProps
) => {
  const { height } = props;
  return (
    <InvertedWrapper height={height} data-testid="loadingSpinner">
      <LoadingIndicator indicatorSize={LoadingIndicator.lg} />
    </InvertedWrapper>
  );
};
